/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react';
import { Redirect, useLocation, useHistory } from 'react-router-dom';
import queryString from 'query-string';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'recompose';

import { Flex } from 'Components/Base';
import Loading from 'Components/Loading';
import { withConfig } from 'Context/ConfigContext';
import { accessTokenService } from 'Util/Hooks/useAccessToken';
import useCookieSession from 'Util/Hooks/useCookieSession';

import { isLoading, isLogin, myRoles } from '../../../Redux/user-profile/selectors';
import { getProfile } from '../../../Redux/user-profile/actions';

const LoginWithToken = ({
  appConfig: { landingRoute = '/my-courses' },
  getProfile,
  isLoading,
  isLogin,
}) => {
  const location = useLocation();
  const history = useHistory();
  const { retrieveCookieSession } = useCookieSession();
  const accessToken = accessTokenService();

  const queryParam = queryString.parse(location.search);
  const { token, redirectUrl = landingRoute } = queryParam;

  useEffect(() => {
    const saveAccessToken = async () => {
      await accessToken.saveAccessToken(token);
      await retrieveCookieSession();
      getProfile();
      history.replace(`/login-loading?redirectPath=${redirectUrl}`);
    };

    if (!isLogin) {
      saveAccessToken();
    }
  }, []);

  if (!isLogin || isLoading) {
    return (
      <Flex justifyContent={'center'} alignItems={'center'} height={'100vh'}>
        <Loading />
      </Flex>
    );
  }
  return <Redirect to={redirectUrl} />;
};

LoginWithToken.propTypes = {
  appConfig: PropTypes.shape({
    landingRoute: PropTypes.string,
  }),
  getProfile: PropTypes.func,
  isLoading: PropTypes.bool,
  isLogin: PropTypes.bool,
};

export default compose(
  connect(
    (state) => ({
      isLoading: isLoading(state),
      isLogin: isLogin(state),
      myRoles: myRoles(state),
    }),
    { getProfile }
  ),
  withConfig
)(LoginWithToken);
